module.exports = __webpack_public_path__ + "img/fr.24841de9.svg";